import styled from 'styled-components';
import _DeleteConfirmModal from 'routes/surface/components/delete-confirm-modal';
import { animated } from 'react-spring';

export const Container = styled.div`
  background-color: #d8d8d8;
`;

export const DeleteConfirmModal = styled(_DeleteConfirmModal)`
  max-width: 960px;
`;

export const KonvaStageHolder = styled(animated.div)``;
